import LabelLang from "component/LabelLang/label-lang";
import { API_BASE_URL } from "configs/AppConfig";
import { DEFAULTS } from "constants/Defaults";
import { DateFormater } from "functions/dateTimeFormat";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

const RelatedNews = ({
  title,
  description,
  publicationDate,
  image,
  id,
  translations,
}) => {
  return (
    <Link to={`/mediaLanding/news/${id}`} className="item-bar related-cards">
      <img
        loading="lazy"
        width={176}
        height={110}
        className="up"
        src={image ? `${API_BASE_URL}/${image}` : DEFAULTS.NEWS}
        alt="item-news"
      />
      <div className="news-dateils">
        <h5>
          <DateFormater value={publicationDate} />
        </h5>
        <h3>
          <div className="title card-title">
            <LabelLang
              id="title"
              defaultValue={title}
              translations={translations}
            />
          </div>
        </h3>

        <div className="rev-item">
          <div className="more">
            <span>
              <FormattedMessage id="read-news" />
            </span>
            <i className="fas fa-ellipsis-h"></i>
          </div>
        </div>
      </div>
    </Link>
  );
};
export default RelatedNews;
